import { grey } from '@mui/material/colors';
import { SxProps, Theme } from '@mui/material/styles';

export const footerCopyrightTypographyBaseSX: SxProps<Theme> = {
	color: grey[500],
	fontSize: '0.75rem',
};
